import { render, staticRenderFns } from "./selectcolor2.vue?vue&type=template&id=4ce23b4a&scoped=true&"
import script from "./selectcolor2.vue?vue&type=script&lang=js&"
export * from "./selectcolor2.vue?vue&type=script&lang=js&"
import style0 from "./selectcolor2.vue?vue&type=style&index=0&id=4ce23b4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce23b4a",
  null
  
)

export default component.exports